import ExcelJS from 'exceljs/dist/exceljs'
const defaultHeaderBackgroundColor = 'f8f8f9'
const defaultCellFontColor = '606266'
const defaultHeadHeight = 20
export default {
  exportExcel(filename, columns, datas, func, isShowTitle = true, groupColumns) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(filename, {
      properties: { tabColor: { argb: 'FF00FF00' } },
    })
    let sheetCols = []
    const colHead = {}
    const tmpColStyle = {}
    const colList = []
    columns.forEach(column => {
      const { field, title, width, align } = column
      colHead[field] = title
      tmpColStyle[field] = {
        align: align,
      }
      if (title !== '操作') {
        sheetCols.push({
          key: field,
          width: width ? width / 8 : 200 / 8,
        })
      }
    })
    if (isShowTitle) {
      // 按开始行，开始列，结束行，结束列合并
      let tmpLen = sheetCols.length
      sheet.mergeCells(1, 1, 1, tmpLen)
      sheet.getCell('A1').value = filename
      sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' }
      sheet.getCell('A1').font = {
        name: 'Arial Black',
        family: 2,
        size: 20,
      }
      sheet.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'fffcd5b4' },
      }
    }
    if (groupColumns && Array.isArray(groupColumns)) {
      const row = sheet.getRow(1)
      groupColumns.forEach(element => {
        sheet.mergeCells(1, element.start, 1, element.end)
        row.getCell(element.start).value = element.label
        row.eachCell(excelCell => {
          let tmpStyle = tmpColStyle[excelCell._column.key] || {}
          Object.assign(excelCell, {
            font: {
              bold: true,
              color: {
                argb: defaultCellFontColor,
              },
            },
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: defaultHeaderBackgroundColor,
              },
            },
            border: this.getDefaultBorderStyle(),
            alignment: {
              vertical: 'middle',
              horizontal: tmpStyle.align || 'left',
            },
          })
        })
      })
    }
    const rowList = datas.map(item => {
      const rest = {}
      columns.forEach(column => {
        rest[column.field] = item[column.field]
      })
      return rest
    })

    workbook.creator = 'jbs-zcm'
    workbook.created = new Date()
    sheet.columns = sheetCols
    colList.push(colHead)
    sheet.addRows(colList).forEach(excelRow => {
      excelRow.height = defaultHeadHeight
      excelRow.eachCell(excelCell => {
        let tmpStyle = tmpColStyle[excelCell._column.key] || {}
        Object.assign(excelCell, {
          font: {
            bold: true,
            color: {
              argb: defaultCellFontColor,
            },
          },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              argb: defaultHeaderBackgroundColor,
            },
          },
          border: this.getDefaultBorderStyle(),
          alignment: {
            vertical: 'middle',
            horizontal: tmpStyle.align || 'left',
          },
        })
      })
    })
    sheet.addRows(rowList)
    workbook.xlsx.writeBuffer().then(buffer => {
      var blob = new Blob([buffer], { type: 'application/octet-stream' })
      // 导出 xlsx
      const linkElem = document.createElement('a')
      linkElem.target = '_blank'
      linkElem.download = `${filename}.xlsx`
      linkElem.href = URL.createObjectURL(blob)
      document.body.appendChild(linkElem)
      linkElem.click()
      document.body.removeChild(linkElem)
      func && func()
    })
  },
  getDefaultBorderStyle() {
    const defaultCellBorderStyle = 'thin'
    const defaultCellBorderColor = 'e8eaec'
    return {
      top: {
        style: defaultCellBorderStyle,
        color: {
          argb: defaultCellBorderColor,
        },
      },
      left: {
        style: defaultCellBorderStyle,
        color: {
          argb: defaultCellBorderColor,
        },
      },
      bottom: {
        style: defaultCellBorderStyle,
        color: {
          argb: defaultCellBorderColor,
        },
      },
      right: {
        style: defaultCellBorderStyle,
        color: {
          argb: defaultCellBorderColor,
        },
      },
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/excelUtils.js